export default "__VITE_ASSET__Bzm2dntp__"